import { useIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

let globalIntl: IntlShape | null = null;


/**
 * @description: 国际化
 * @param {string} key/中文键
 * @param {Record} values/动态插值，如{name:123}
 * @return {*}
 */
export const $t = (key: string, values: Record<string, any> = {}) => {
    try {
        if (!globalIntl) {
            globalIntl = useIntl();
        }
        return globalIntl.formatMessage(
            {
                id: key,
                defaultMessage: key,
            },
            {
                ...values
            },
        );
    } catch (e) {
        // 非hook返回key
        return key;
    }
};